import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { groupByOptions } from "../../main-container/studio/studio-constants";

@Component({
  selector: "app-group-by-dropdown",
  templateUrl: "./group-by-dropdown.component.html",
  styleUrl: "./group-by-dropdown.component.scss"
})
export class GroupByDropdownComponent implements OnInit, OnDestroy {
  groupByOptions: any[] = [];
  @Input() selectedGroupBy: any[] = [];
  @Input() panelClassName: string = "";
  @Output() groupByChange: EventEmitter<any> = new EventEmitter();

  private langChangeSubscription?: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.updateGroupByOptions();
    this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.updateGroupByOptions();
    });
  }

  ngOnDestroy(): void {
    this.langChangeSubscription?.unsubscribe();
  }

  private updateGroupByOptions(): void {
    this.groupByOptions = groupByOptions.map((option: any) => ({
      ...option,
      label: this.translate.instant(option.label)
    }));
  }

  onGroupByChange() {
    this.groupByChange.emit(this.selectedGroupBy);
  }
}
